import React from "react";
import { Clock, Users, MapPin } from "lucide-react";
import { IMAGES } from "../constants";
import { useLanguage } from "../contexts/LanguageContext";

export const About = () => {
  const { t } = useLanguage();
  const features = [
    { icon: Clock, title: t.about.feature_1_title, text: t.about.feature_1_text },
    { icon: Users, title: t.about.feature_2_title, text: t.about.feature_2_text },
    { icon: MapPin, title: t.about.feature_3_title, text: t.about.feature_3_text },
  ];

  return (
    <section
      id="ueber-uns"
      className="relative py-20 md:py-32 px-5 md:px-8 lg:px-12 bg-[#05080F]"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        <div className="relative aspect-[4/5] overflow-hidden rounded-2xl" data-testid="about-image">
          <img
            src={IMAGES.about}
            alt="Barber bei der Arbeit im YOUR CUT Salon"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0D14] via-transparent to-transparent" />
          <div className="absolute bottom-5 left-5 right-5 md:bottom-6 md:left-6 md:right-6">
            <p className="font-script italic text-white/90 text-lg md:text-2xl">
              "Handmade in Hamburg"
            </p>
          </div>
        </div>

        <div>
          <p className="font-script text-[#E63946] text-base md:text-xl mb-3">
            — {t.about.eyebrow}
          </p>
          <h2
            className="font-heading font-bold uppercase tracking-tight text-3xl sm:text-5xl md:text-6xl text-white mb-6 md:mb-8 leading-[0.95]"
            data-testid="about-title"
          >
            {t.about.title}
          </h2>
          <p className="text-white/75 text-sm sm:text-base md:text-lg leading-relaxed mb-4 md:mb-5">
            {t.about.p1}
          </p>
          <p className="text-white/60 text-sm sm:text-base md:text-lg leading-relaxed mb-8 md:mb-10">
            {t.about.p2}
          </p>

          <div className="grid sm:grid-cols-3 gap-4 md:gap-6">
            {features.map((f, i) => (
              <div
                key={i}
                className="p-4 md:p-5 rounded-xl bg-white/[0.03] border border-white/10 hover:border-[#E63946]/50 transition-colors"
                data-testid={`about-feature-${i}`}
              >
                <f.icon className="w-5 h-5 md:w-6 md:h-6 text-[#E63946] mb-2 md:mb-3" />
                <h3 className="font-heading uppercase tracking-wide text-sm text-white mb-1.5 md:mb-2">
                  {f.title}
                </h3>
                <p className="text-xs sm:text-sm text-white/60 leading-relaxed">{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
